module.exports = __webpack_public_path__ + "static/media/filter.f944769e.svg";